package de.ohhhmhhh.frontend.admin.ui.screens.revocation

import de.ohhhmhhh.backend.models.model.revocation.RevocationContractTypeEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationEntity
import de.ohhhmhhh.backend.models.model.revocation.RevocationStateEntity

data class RevocationListState(
    val items: List<RevocationEntity> = emptyList(),
    val search: String? = null,
    val contractType: RevocationContractTypeEntity? = null,
    val state: RevocationStateEntity? = null,
    val page: Int = 0,
    val pageCount: Int = 0,
    val resultCount: Int = 0
)
